








import Vue from 'vue'
import { Polyline as TripLine } from 'vue2-google-maps'
import { apiGetDebugTripDetails } from '@/api'
import { tracefyOrange } from '@/plugins/vuetify'

export default Vue.extend({
  name: 'Trip',
  props: {
    tripId: String,
  },
  components: { TripLine },
  data() {
    return {
      trip: null
    }
  },
  methods: {
    loadTrip (entity_id: string, trip_id: string) {
      apiGetDebugTripDetails(entity_id, trip_id).then((res) => {
        const path: any[] = []
        const trip = res.data.data

        trip.waypoints.forEach((w: any) => {
          path.push({
            lat: w.position.latitude,
            lng: w.position.longitude
          })
        })

        const tripData = {
          path,
          id: trip.id,
          geodesic: true,
          strokeColor: tracefyOrange,
          strokeWeight: 5,
          startMarker: {
            position: path[0]
          },
          endMarker: {
            position: path[path.length - 1]
          },
          strokeOpacity: 0,
          icons: [{
            icon: {
              path: 'M 0, 0 0, 0.1',
              strokeOpacity: 1,
              scale: 5
            },
            offset: '0',
            repeat: '10px'
          }]
        }

        this.trip = tripData

        const { tripStartMarker, tripEndMarker, tripLine } = this.$refs

        const map =  this.$parent.$mapObject

        tripStartMarker.$markerObject.setMap(map)
        tripEndMarker.$markerObject.setMap(map)
        tripLine.$polylineObject.setMap(map)

        const bounds = new google.maps.LatLngBounds()
        tripData.path.forEach((b: google.maps.LatLng) => bounds.extend(b))
        map.fitBounds(bounds)
      })
    },
    clearRenderedTrip() {
      const { tripStartMarker, tripEndMarker, tripLine } = this.$refs

      tripStartMarker.$markerObject.setMap(null)
      tripEndMarker.$markerObject.setMap(null)
      tripLine.$polylineObject.setMap(null)
      this.trip = null
    }
  }
})
